import { Route, Routes } from '@angular/router';
import { Action, createAction, props } from '@ngrx/store';
import { AumicoUser } from '../../interfaces/aumico.routing';
import { IPageHeader } from '../../interfaces/pageHeader.interface';

export interface INavigationEvent {
    route: Route | null;
}

export interface IUpdateNavigationEvent {
    items: Routes;
}

export interface IUpdateUserEvent {
    user: AumicoUser;
}

export const onShouldNavigateToRoute = createAction(
    '[Aumico-Layout] onShouldNavigateToRoute',
    props<{ payload: INavigationEvent }>(),
);

export const onPageNavigation = createAction(
    '[Aumico-Layout] onPageNavigation',
    props<{ payload: INavigationEvent }>(),
);

export const onSubNavigation = createAction('[Aumico-Layout] onSubNavigation', props<{ payload: INavigationEvent }>());

export const updateSubNavigation = createAction(
    '[Aumico-Layout] updateSubNavigation',
    props<{ payload: IUpdateNavigationEvent }>(),
);

// Layout Actions
export const updateLayoutIsHidden = createAction('[Aumico-Layout] updateLayoutIsHidden', props<{ payload: boolean }>());

export const changePageHeader = createAction('[Aumico-Layout] changePageHeader', props<{ payload: IPageHeader }>());

// User Actions
export const updateUser = createAction('[Aumico-Layout] updateUser', props<{ payload: IUpdateUserEvent }>());

// Router Config
export const initRouterConfig = createAction('[Aumico-Layout] initRouterConfig', props<{ payload: Routes }>());

// Navigation
export const updatePrimaryNavigation = createAction(
    '[Aumico-Layout] updatePrimaryNavigation',
    props<{ payload: Routes }>(),
);
export const updateSecondaryNavigation = createAction(
    '[Aumico-Layout] updateSecondaryNavigation',
    props<{ payload: Routes }>(),
);

export const updateUserNavigation = createAction('[Aumico-Layout] updateUserNavigation', props<{ payload: Route }>());

export const updateHideFooterOption = createAction(
    '[Aumico-Layout] updateHideFooterOption',
    props<{ payload: boolean }>(),
);

export const resetLayout = createAction('[Aumico-Layout] resetLayout');

export interface ActionWithPayload<T> extends Action {
    payload: T;
}
